import { makeStyles } from '@material-ui/core';

export const TotalTableRowStyle = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.secondary.light,
    },
}));
